const TOP_OFFSET = 40;
const LEFT_OFFSET = 35;

export const top = `calc(100% - ${TOP_OFFSET}px)`;
export const left = `calc(100% - ${LEFT_OFFSET}px)`;
export const PAGE_NUMBER_FONT_FAMILY = 'Inter';
export const DEFAULT_STYLE = {
  fontSize: 20,
  fontFamily: PAGE_NUMBER_FONT_FAMILY,
  fontWeight: 'normal',
  fontStyle: 'normal',
  textDecoration: 'none',
};
export const EDITABLE_PAGE_NUMBER_ID = 'editable-page-number';
// The main selector for the page number - if this is updated export has to be updated as well
export const PAGE_NUMBER_EXPORT_CLASSNAME = 'page-number-base';
